"use client";
import useGetReferral from "@/hooks/cred/useGetReferral";

import { SupLoader } from "@repo/core-ui";
import { SupCopy } from "@repo/core-ui";
import React, { useEffect, useMemo } from "react";
import UiCopy from "@/components/Ui/Copy";
import { handleReferralCode } from "@/utils/referral";
import CTA from "@/components/Cred/UI/CTA";
import useWeb3UserAddress from "@/hooks/web3/useWeb3UserAddress";
import { twMerge } from "tailwind-merge";

export default function Referral({ className }: { className?: string }) {
  const userAddress = useWeb3UserAddress();
  const { data, isLoading, isError } = useGetReferral();

  const referralLink = useMemo(() => {
    if (data?.code) {
      const origin = window.location.origin;
      return `${origin}/explore?ref=${data.code}`;
    }
    return "";
  }, [data?.code]);

  useEffect(() => {
    handleReferralCode();
  }, []);

  // Show loading state while waiting for user address
  if (!userAddress) {
    return (
      <CTA
        topChild="Refer to earn. Evangelize to maximize."
        bottomChild={
          <div className="flex items-center justify-center">
            <SupLoader isSmall />
          </div>
        }
      />
    );
  }

  // Show error state
  if (isError) {
    return <CTA topChild="Refer to earn. Evangelize to maximize." bottomChild={<div className="text-red-500">Failed to load referral code. Please try again.</div>} />;
  }

  return (
    <CTA
      className={twMerge("", className)}
      topChild="Refer to earn. Evangelize to maximize."
      bottomChild={
        <div className="flex items-center justify-center space-x-1">
          {isLoading && <SupLoader isSmall />}
          {data?.code && (
            <UiCopy variant="text" text={referralLink} className="h-10 w-fit cursor-pointer p-0 hover:bg-transparent enabled:hover:bg-transparent">
              <div className="flex items-center space-x-2  ">
                <SupCopy className="h-4 w-4 text-neutral-900" />
                <span className="text-base text-neutral-900 underline underline-offset-2 hover:no-underline">COPY REFERRAL LINK</span>
              </div>
            </UiCopy>
          )}
        </div>
      }
    />
  );
}
